import StorageNearYou from 'assets/images/psp/storage-near-you/storage-near-you.svg';

const TITLE_BUILDERS = {
	Electricity: (type, state, _city) => ({
		title: `Self Storage with ${type}: Browse More Locations`,
		nearbyTitle: `More Self Storage with ${type} in Nearby Cities`,
		stateTitle: `More Self Storage with ${type} Across ${state}`,
		statesLinkTitle: `More Self Storage with ${type} in Major Cities`,
	}),
	Facility: (type, state, city) => ({
		title: 'Find Self Storage Near You',
		nearbyTitle:
			city && state
				? `Self Storage in Cities Near ${city}, ${state}`
				: 'Self Storage in Nearby Cities',
		stateTitle: state
			? `Self Storage in ${state}`
			: 'Self Storage in Your Area',
		statesLinkTitle: 'Self Storage in Other Popular Cities',
	}),
	StorageSize: (type, state, city) => ({
		title: 'Find Storage Near You',
		nearbyTitle: city
			? `Storage facilities near ${city}`
			: 'Storage facilities in nearby cities',
		stateTitle: state
			? `Storage facilities in ${state}`
			: 'Storage facilities in your area',
		statesLinkTitle: 'Storage facilities across the country',
	}),
};

const defaultTitleBuilder = (type, state) => ({
	title: `${type} Self Storage: Browse More Locations`,
	nearbyTitle: `More ${type} Self Storage in Nearby Cities`,
	stateTitle: `More ${type} Self Storage Across ${state}`,
	statesLinkTitle: `More ${type} Self Storage in Major Cities`,
});

export const StorageNearYouData = (type = '', state = '', city = '') => {
	const titles = (TITLE_BUILDERS[type] ?? defaultTitleBuilder)(
		type,
		state,
		city,
	);

	return {
		title: titles.title,
		image: StorageNearYou,
		nearByDetectedCities: {
			title: titles.nearbyTitle,
			cities: [],
		},
		citiesByState: {
			title: titles.stateTitle,
			cities: [],
		},
		statesLink: {
			title: titles.statesLinkTitle,
			cities: [
				{
					slug: '/self-storage/new-york/new-york/',
					name: 'New York, NY',
				},
				{
					slug: '/self-storage/california/los-angeles/',
					name: 'Los Angeles, CA',
				},
				{
					slug: '/self-storage/texas/houston/',
					name: 'Houston, TX',
				},
				{
					slug: '/self-storage/massachusetts/boston/',
					name: 'Boston, MA',
				},
				{
					slug: '/self-storage/texas/austin/',
					name: 'Austin, TX',
				},
				{
					slug: '/self-storage/nevada/las-vegas/',
					name: 'Las Vegas, NV',
				},
				{
					slug: '/self-storage/florida/miami/',
					name: 'Miami, FL',
				},
				{
					slug: '/self-storage/washington/seattle/',
					name: 'Seattle, WA',
				},
				{
					slug: '/self-storage/colorado/denver/',
					name: 'Denver, CO',
				},
				{
					slug: '/self-storage/georgia/atlanta/',
					name: 'Atlanta, GA',
				},
			],
		},
	};
};
